export const FETCH_ASSESMENT_REQUEST     = "FETCH_ASSESMENT_REQUEST";
export const FETCH_ASSESMENT_SUCCESSFUL  = "FETCH_ASSESMENT_SUCCESSFUL";
export const FETCH_ASSESMENT_FAILURE     = "FETCH_ASSESMENT_FAILURE";

export const UPDATE_ASSESMENT_REQUEST     = "UPDATE_ASSESMENT_REQUEST";
export const UPDATE_ASSESMENT_SUCCESSFUL  = "UPDATE_ASSESMENT_SUCCESSFUL";
export const UPDATE_ASSESMENT_FAILURE     = "UPDATE_ASSESMENT_FAILURE";